import { useQuery } from '@tanstack/react-query';
import { authApi } from '@/lib/api';
import type { UserProfile } from '@/types';

// Query keys
export const userKeys = {
  all: ['user'] as const,
  me: () => [...userKeys.all, 'me'] as const,
};

/**
 * Hook for fetching current user info from the /oauth/me endpoint.
 */
export function useUser() {
  return useQuery({
    queryKey: userKeys.me(),
    queryFn: (): Promise<UserProfile> => authApi.getMe(),
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });
}
